import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
    leaderTtile: {
        fontFamily: "Manrope",
        fontSize: "14px",
        lineHeight:  "24px",
        fontWeight: "bold",
        color: "#465869"
    },
    leaderDescription: {
        fontFamily: "Manrope",
        fontWeight: 500,
        lineHeight:  "16px",
        color: "#9CA6AF"
    },
    mt24: {
        marginTop:  "24px"
    },
    mt12: {
        marginTop: "12px"
    }
}))

export default styles